import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlBase } from '../../../base/control-base/control-base.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'export-button-control',
    standalone: false,
    template: `
        <button class="btn" [appClickWait]="onClick">
            <img src="@imagesDir/export.png" />
            <span class="mx-1">{{ buttonText | translate }}</span>
        </button>
    `,
    styles: `
        button > img {
            width: 24px;
            height: 24px;
        }

        .btn span {
            writing-mode: horizontal-tb;
            text-orientation: mixed;
            display: inline;
        }
    `
})
export class ExportButtonControl extends ControlBase {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
    }

    @Input() buttonText: string = '';
    
    @Output() clicked = new EventEmitter<void>();

    public onClick = async (): Promise<any> => {
        this.clicked.emit();
    };
}
